import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type IndentDecreaseActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const IndentDecreaseAction = ({ compact = true, showBoxShadow = true, ...rest }: IndentDecreaseActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' className={flexCenter}>
        <Icon name='indent-decrease-small' />
      </Text>
    </ActionPressedChip>
  );
};
